import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-generic-outlet',
    template: '<router-outlet></router-outlet>',
    imports: [RouterOutlet]
})
export class GenericOutletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
